export default __webpack_public_path__ + "static/media/a011-PPII-4.5f84e2eb.svg";